import Vue from 'vue';
import Router from 'vue-router';
import Login from './components/Login';
import Home from './components/Home';
import Reset from './components/Reset';
import AnswerWithCode from './components/AnswerWithCode';
import LoginWithToken from './components/LoginWithToken';
import InitPassword from './components/InitPassword';

Vue.use(Router);

export default new Router({
  mode: `history`,
  base: process.env.BASE_URL,
  routes: [
    {
      path: `/form`,
      name: `Login`,
      component: Login,
    },
    {
      path: `/`,
      name: `Home`,
      component: Home,
    },
    {
      path: `/reset`,
      name: `Reset`,
      component: Reset,
    },
    {
      path: `/code`,
      name: `AnswerWithCode`,
      component: AnswerWithCode,
    },
    {
      path: `/with-token/:token`,
      name: `LoginWithToken`,
      component: LoginWithToken,
    },
    {
      path: `/init-password/:token`,
      name: `InitPassword`,
      component: InitPassword,
    },
  ],
});
